import styled from 'styled-components/';
import AppCSS from '../../../utils/styled';
import Radio from '@mui/material/Radio';
import { SMALLER_BUTTON_WIDTH } from '../../../utils/styled/dimensions';

export const Components = {
  ModalBodyContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-top: 16px;
    width: 100%;
  `,
  ModalButtonsContainer: styled.div`
    width: 100%;
    padding: 12px 0;
    grid-gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  Button: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${SMALLER_BUTTON_WIDTH}px;
    min-width: ${SMALLER_BUTTON_WIDTH}px;
  `,
  CancelButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,
  RadioItemContainer: styled.div<{ isChecked: boolean }>`
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 93px;
    width: 100%;
    ${AppCSS.radiuses.default};
    border: 1px solid ${(p) => (p.isChecked ? AppCSS.colors.blues.dark : AppCSS.colors.blues.veryLight)};
    ${(p) => p.isChecked && `background-color: ${AppCSS.colors.blues.veryLight};`};
    margin: 4px 0;
  `,
  RadioItemLabel: styled.span`
    ${AppCSS.fonts.label16Regular};
    color: ${AppCSS.colors.black};
  `,
  RadioItemCheckbox: styled(Radio)`
    &.Mui-checked {
      color: ${AppCSS.colors.blues.dark};
    }
    color: ${AppCSS.colors.blues.light};
    width: 20px;
    height: 20px;
  `,
};
